<template>
  <div class="app-container">
    <!-- <BjRouteTabs /> -->
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="isInform ? colSpan : colSpan * 2" :get-action="queryApi"
      :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.code" :label="$t('BusinessPurchaseEntryComPage.code')" prop="code"
            @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsCom.purchaseCode')" prop="purchaseCode">
            <BjInput v-model="queryParams.purchaseCode" :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseEntryComPage.applyCode')" prop="applyCode">
            <BjInput v-model="queryParams.applyCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')"
              clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseEntryComPage.header.warehouseCode')" prop="warehouseCode">
            <BjSelectWarehouse
              v-model="queryParams.warehouseCode"
              value-code="code"
              :type-code="['logic']"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.invoiceNo" :label="$t('BusinessPurchaseComponentsCom.invoiceNo')"
            prop="purchaseCode" @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsCom.PO.stockinStatusMeaning')" prop="status">
            <BjSelectLov v-model="queryParams.status" :option-list="INCOMING_TYPE" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.skuCode" :label="$t('BusinessPurchaseEntryComPage.header.skuCode')"
            prop="skuCode" @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <BjDateTimerangePicker v-model="queryParamsTime_create" :placeholder="$t('table.createTimeText')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseEntryComPage.header.storageTime')">
            <BjDateTimerangePicker v-model="queryParamsTime_required" :placeholder="$t('BusinessPurchaseEntryComPage.header.storageTime')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
         <el-button class="ml5" type="primary" :disabled="!selectedRows.length" @click="pushSap">{{ $t('BusinessPurchaseEntryComPage.pushSap') }}</el-button>
          <!-- <el-col> -->
          <!-- <template v-if="isInform"> -->
            <!-- <el-button v-permission:BusinessPurchaseEntryInformAdd type="primary" class="main-btn" @click="onAdd">{{$t('BusinessPurchaseEntryComPage.addOrder') }}</el-button> -->
            <!--            <el-button-->
            <!--              v-permission:BusinessPurchaseEntryInformEdit-->
            <!--              type="primary"-->
            <!--              :disabled="tableOperationProp.notSingle"-->
            <!--              @click="onUpdata"-->
            <!--              >{{ $t('editText') }}</el-button-->
            <!--            >-->
            <!-- <el-button v-permission:BusinessPurchaseOrderIndexEdit type="primary" :disabled="tableOperationProp.notSelected" @click="onDeleteSelected">{{ $t('delText') }}</el-button> -->
            <!-- <el-dropdown :disabled="tableOperationProp.notSelected" @command="onAudit">
              <el-button type="primary">
                {{ $t('BusinessPurchaseEntryComPage.review') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-permission:BusinessPurchaseEntryInform_Audit
                  :command="$t('BusinessPurchaseEntryComPage.review')"
                  :disabled="tableOperationProp.notSelected"
                  >{{ $t('BusinessPurchaseEntryComPage.review') }}</el-dropdown-item
                >
                <el-dropdown-item
                  v-permission:BusinessPurchaseEntryInform_UnAudit
                  :command="$t('BusinessPurchaseEntryComPage.antiAudit')"
                  :disabled="tableOperationProp.notSingle"
                  >{{ $t('BusinessPurchaseEntryComPage.antiAudit') }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown> -->

            <!-- <el-button
              v-permission:BusinessPurchaseEntryInform_Cancel
              type="primary"
              :disabled="tableOperationProp.notSingle"
              @click="onCancel"
              >{{ $t('cancelText') }}</el-button
            > -->

            <!-- v-permission:BusinessPurchaseEntryInform_Confirm -->
            <!-- <el-button
              type="primary"
              :disabled="tableOperationProp.notSingle"
              @click="onConfirm"
              >{{ $t('BusinessPurchaseEntryComPage.confirmStorage') }}</el-button
            > -->
          <!-- </template> -->
          <!-- <el-button
            v-permission="
              isInform ? 'BusinessPurchaseEntryInform_Export' : 'BusinessPurchaseEntryResult_Export'
            "
            type="primary"
            @click="onExport"
            >{{ $t('BusinessPurchaseEntryComPage.export') }}</el-button
          > -->
        <!-- </el-col>-->
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center"
            class-name="item">
            <template slot-scope="{ row }">
              <template v-if="false" />
              <template v-else-if="col.prop === 'code'">
                <span class="link" @click="onDetail(row)">{{ row[col.prop] }}</span>
                <BjCopyIcon :copy="row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'purchaseCode'">
                <span @click="toPurchaseOrder(row)">{{ row[col.prop] }}</span>
                <BjCopyIcon :copy="row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'applyCode'">
                <span>{{ row[col.prop] }}</span>
                <BjCopyIcon :copy="row[col.prop]" />
              </template>
              <span v-else-if="col.prop === 'stockinCode'" class="link" @click="onInformDetail(row)">
                {{ row[col.prop] }}
              </span>
              <template v-else-if="col.prop === 'status'">{{ $t(INCOMING_TYPE.bjGet(row[col.prop])) }}</template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template v-slot="{ row }">
              <el-button type="text" class="delete-btn" @click="onDetail(row)">{{ $t('BusinessPurchaseOrderList.View')
              }}</el-button>
              <!-- <el-dropdown :disabled="row.status === 'ALL_STOCKIN'" size="mini"
                @command="command($event, row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i
                    class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="stock">{{
                    $t('BusinessPurchaseEntryComPage.confirmStorage') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi, tagsApi } from '@/api';
import { STATUS_YES_TRUE, INCOMING_TYPE } from '@/utils/constants';
import { downloadBlob } from '@/utils/index';
import DataForm from './DataForm';

export default {
  components: { DataForm },
  mixins: [pageMiXin],
  props: {
    pageType: {
      type: String,
      default: 'inform',
      validator: value => {
        return ['inform', 'result'].includes(value);
      },
    },
    queryApi: Function,
  },
  data() {
    return {
      STATUS_YES_TRUE,
      INCOMING_TYPE,
      // 查询参数
      queryParamsTime_create: null,
      queryParamsTime_document: null,
      queryParamsTime_required: null,
      queryParams: {
        code: null,
        queryCode: null,
        supplier: null,
        type: null,
        warehouseCode: null,
        purchaseCode: null,
        status: null,
        spuCode: null,
        skuCode: null,
        creationDateBegin: null,
        creationDateEnd: null,
        auditDateBegin: null,
        auditDateEnd: null,
        stockinDateBegin: null,
        stockinDateEnd: null,
        postingDateBegin: null,
        postingDateEnd: null,
        documentDateBegin: null,
        documentDateEnd: null,
        requiredDateBegin: null,
        requiredDateEnd: null,
        applyCode: null,
        invoiceNo: null
      },
      labelsVersion: 0,
      commonErrorText: this.$t('BusinessPurchaseEntryComPage.errorText'),
      SKU_TAG_LIST: [],
    };
  },
  computed: {
    isInform() {
      return this.pageType === 'inform';
    },
    labelList() {
      return [
        { label: this.$t('BusinessPurchaseEntryComPage.code'), prop: 'code', isCheck: true, disabled: false, width: '210' },
        { label: this.$t('BusinessPurchaseComponentsCom.purchaseCode'), prop: 'purchaseCode', isCheck: true, disabled: false, width: '155' },
        { label: this.$t('BusinessPurchaseEntryComPage.applyCode'), prop: 'applyCode', isCheck: true, disabled: false, width: '153' },
        // {label: '收货仓库', prop: 'supplierName', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('BusinessPurchaseComponentsCom.PO.stockinStatusMeaning'), prop: 'status', isCheck: true, disabled: false, width: '150' },
        { label: this.$t('BusinessPurchaseComponentsCom.invoiceNo'), prop: 'invoiceNo', isCheck: true, disabled: false, width: '160' },
        // { label: this.$t('BusinessPurchaseOrderList.tolerance'), prop: 'dataFaultToleranceQty', isCheck: true, disabled: false, width: '88' },
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseComponentsCom.PO.loosDate'), prop: 'loosDate', isCheck: true, disabled: false},
        // { label: this.$t('BusinessPurchaseEntryComPage.header.storageTime'), prop: 'lastUpdateDate', isCheck: true, disabled: false, width: '150' },
        // { label: this.$t('BusinessStockEntryInformView.totalQty'), prop: 'planQty', isCheck: true, disabled: false, width: '120' },
        // { label: this.$t('BusinessPurchaseEntryComPage.table.alreadyQty'), prop: 'alreadyQty', isCheck: true, disabled: false, width: '120' },
        // { label: this.$t('BusinessPurchaseComponentsCom.waitQty'), prop: 'waitQty', isCheck: true, disabled: false, width: '97' },
        { label: this.$t('table.creatorText'), prop: 'createdName', isCheck: true, disabled: false},
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '100' },
      ];
    },
  },
  watch: {
    queryParamsTime_create(v) {
      this.queryParams.postingDateBegin = (v || [])[0];
      this.queryParams.postingDateEnd = (v || [])[1];
    },
    queryParamsTime_document(v) {
      this.queryParams.documentDateBegin = (v || [])[0];
      this.queryParams.documentDateEnd = (v || [])[1];
    },
    queryParamsTime_required(v) {
      this.queryParams.requiredDateBegin = (v || [])[0];
      this.queryParams.requiredDateEnd = (v || [])[1];
    },
  },
  mounted() {
    this.getSkuTagList();
  },
  methods: {
    pushSap() {
      const orderStatus = this.selectedRows.every(item => item.status === 'FAIL_PUSH_SAP');
      if (!orderStatus) return this.$message.error(this.$t('BusinessPurchaseEntryComPage.errMsg1'));
      const codeList = this.selectedRows.map(item => item.code);
      purchaseApi.stockingPushSAP(codeList).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    /** 获取sku标签*/
    getSkuTagList() {
      const data = {
        labelType: 9,
        systemLabelFlag: false,
        pageSize: 40
      };
      tagsApi.getLabels(data).then(res => {
        if (!res.content.length) return;
        this.SKU_TAG_LIST = res.content.map(item => {
          return {
            label: item.textContent,
            value: item.labelCode
          };
        });
      });
    },
    command(text, row) {
      switch (text) {
        case 'stock':
          this.stock(row);
          break;
      }
    },
    stock(row) {
      this.popupType = 'stock';
      const title = this.$t('BusinessPurchaseEntryComPage.warehouseTitle');
      const data = {
        title,
        data: row
      };
      this.$refs.DataForm.show(data);
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_create = null;
      this.queryParamsTime_document = null;
      this.queryParamsTime_required = null;
      this.queryParams.invoiceNo = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    // 跳转采购单详情
    toPurchaseOrder(row) {
      // this.$toPage('BusinessPurchaseDetail', {
      //   code: row.purchaseCode,
      // });
    },
    onDetail(row) {
      const name = this.isInform
        ? 'BusinessPurchaseEntryInformDetail'
        : 'BusinessPurchaseEntryResultDetail';
      this.$toPage(name, {
        id: row.id,
        code: row.code,
      });
    },
    onInformDetail(row) {
      this.$toPage('BusinessPurchaseEntryInformDetail', { id: row.id, code: row.stockinCode });
    },
    /** 新增 */
    onAdd() {
      this.$router.push({
        name: 'BusinessPurchaseEntryInformAdd',
      });
    },
    /** 修改 */
    onUpdata() {
      const { id, code, statusMeaning } = this.selectedRows[0];
      if (statusMeaning !== '待入库') {
        this.msgError(this.$t('BusinessPurchaseEntryComPage.msgError'));
        return;
      }
      this.$router.push({
        name: 'BusinessPurchaseEntryInformEdit',
        query: {
          id,
          code,
        },
      });
    },
    /** 审核/反审核 */
    onAudit(command) {
      const setData = new Set(this.selectedRows.map(e => e.status));
      // 审核
      if (command === this.$t('BusinessPurchaseEntryComPage.review')) {
        // 混合状态并且不是待审核
        if (setData.size > 1 || (setData.size === 1 && !setData.has('WAIT_AUDIT'))) {
          this.msgError(this.commonErrorText);
          return;
        }
      } else {
        // 状态非待入库相关
        if (!setData.has('WAIT_STOCKIN')) {
          this.msgError(this.commonErrorText);
          return;
        }
      }
      this.$MessageBox({ content: `${this.$t('BusinessPurchaseEntryComPage.msgBox1')} ${command} ${this.$t('BusinessPurchaseEntryComPage.msgBox2')}` }).then(() => {
        const Api = command === this.$t('BusinessPurchaseEntryComPage.review') ? 'auditStockins' : 'antiAuditStockins';
        const ids = {
          ids: this.selectedRows.map(row => {
            const { id, objectVersionNumber } = row;
            return {
              id,
              objectVersionNumber,
            };
          }),
        };
        this.operationApi(Api, ids);
      });
    },
    /** 取消 */
    onCancel() {
      // 判断待审核状态下才能取消
      if (this.selectedRows[0].status !== 'WAIT_AUDIT') {
        this.msgError(this.commonErrorText);
        return;
      }
      this.$MessageBox({ content: this.$t('BusinessPurchaseEntryComPage.msgBox3') }).then(() => {
        const ids = {
          ids: this.selectedRows.map(row => {
            const { id, objectVersionNumber } = row;
            return {
              id,
              objectVersionNumber,
            };
          }),
        };
        this.operationApi('cancelStockins', ids);
      });
    },
    /** 采购确认 */
    onConfirm() {
      // 判断不是待入库和部分入库状态
      if (!['WAIT_STOCKIN', 'PARTIAL_STOCKIN'].includes(this.selectedRows[0].status)) {
        this.msgError(this.commonErrorText);
        return;
      }
      this.$MessageBox({ content: this.$t('BusinessPurchaseEntryComPage.msgBox4') }).then(() => {
        const ids = this.selectedRows.map(row => row.id);
        this.operationApi('generateResultsByStockins', ids);
      });
    },
    /** 导出 */
    onExport() {
      purchaseApi[this.isInform ? 'reportStockins' : 'reportstockinResults'](this.queryParams).then(
        res => {
          downloadBlob(
            res,
            (this.isInform ? this.$t('BusinessPurchaseEntryComPage.downName1') : this.$t('BusinessPurchaseEntryComPage.downName2')) +
            new Date().toLocaleString() +
            '.xlsx',
          );
        },
      );
    },
    /** 删除 */
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => { });
    },
    batchDeleteApi(ids) {
      purchaseApi.deleteStockins(ids).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    operationApi(apiName, DATA) {
      purchaseApi[apiName](DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
